export class IdentityInfo{
    public ownerName?: string;
    public url?: string;
    public did?: string;
    public verkey?: string;
}